import * as React from 'react';
import * as Sentry from '@sentry/browser';

import {
  Lang,
  Colors,

  useDimensions,

  LargeContainer,
  Container,
  TextBlock,

  scrollToId,
} from '@bluecurrent/web-component-lib';

import Setup from '../../config/setup';

import HasAlreadyReserved from '../Modules/HasAlreadyReserved';

export default function NewLanding(props) {
  const size = useDimensions();
  const { _ } = Lang.useTranslation();

  const isMobile = size.width < 830;

  return (
    <div
      style={{
        width: '100%',
        minWidth: 320,
        height: 'auto',
      }}
    >
      <LargeContainer>
        <div
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: Colors.GRADIENT,
            backgroundImage: isMobile ? 'initial' : 'url("https://cdn.sanity.io/images/pnajo2cq/production/8649dc5a7fab2383e7063b82159f32634ab07458-1900x1080.jpg")',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderTopLeftRadius: size.width < 1440 ? 0 : 10,
            borderTopRightRadius: size.width < 1440 ? 0 : 10,
            borderBottomLeftRadius: size.width < 1440 ? 0 : 10,
            borderBottomRightRadius: size.width < 1440 ? 0 : 10,
            position: 'relative',
            overflow: 'hidden',
            marginTop: size.width < 1100
              ? 120
              : size.width < 1440
                ? 160
                : 190,
          }}
        >
          <Container
            share={[50, 50]}
            breakpoint={830}
          >
            <div
              style={{
                width: isMobile ? 'auto' : '100%',
                height: 'auto',
                minHeight: isMobile ? '10svh' : '65svh',
                marginTop: size.width >= 1100 && size.width < 1440 ? 70 : 30,
                marginBottom: 30,
                marginLeft: isMobile ? '3%' : '8%',
                marginRight: isMobile ? '3%' : '8%',
                position: 'relative',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                backgroundColor: isMobile ? 'transparent' : Colors.WHITE,
                borderRadius: 30,
                paddingLeft: isMobile ? 0 : 60,
                paddingRight: isMobile ? 0 : 60,
                paddingTop: 30,
                paddingBottom: 30,
              }}
            >
              <TextBlock
                title={{
                  content: props.title,
                  fontSize: '2.8em',
                  fontWeight: 700,
                  portableText: true,
                }}
                text={{
                  content: props.text,
                  portableText: true,
                }}
                buttons={!Setup.SUCCESS && [
                  {
                    id: 0,
                    customId: 'Button_DownloadPitchDeckLink',
                    text: _('invest.downloadPitchDeck', { ns: 'branding' }),
                    size: 'medium',
                    onClick: () => {
                      Sentry.captureMessage('[invest] Landing Download Pitch Deck');
                      scrollToId({
                        id: 'pitch-deck',
                        duration: 1500,
                      });
                    },
                    colorScheme: 'blue',
                  },
                ]}
                align="left"
              />
            </div>
            <div />
          </Container>
          <div
            style={{
              width: '50%',
              height: '100%',
              background: 'linear-gradient(90deg,rgba(229, 244, 251, 1) 20%, rgba(229, 244, 251, 0) 100%)',
              opacity: 1,
              position: 'absolute',
              top: 0,
              left: '20%',
            }}
          />
          <div
            style={{
              width: '20%',
              height: '100%',
              backgroundColor: Colors.GRADIENT,
              opacity: 1,
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          />
          {
            !isMobile && (
              <div
                style={{
                  height: 700,
                  width: 700,
                  minWidth: 600,
                  borderRadius: '50%',
                  background: 'linear-gradient(90deg,rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%)',
                  opacity: 0.3,
                  position: 'absolute',
                  left: -30,
                  top: -30,
                }}
              />
            )
          }
        </div>
        <HasAlreadyReserved
          amount={props.amount}
          lastUpdate={props.lastUpdate}
        />
        <div
          style={{
            marginTop: 50,
            width: '100%',
            height: 50,
            backgroundImage: 'url("/awards.png")',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        />
      </LargeContainer>
    </div>
  );
}
